import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={() => changeLanguage('uk')}
        className={`px-2 py-1 text-sm font-bold rounded transition ${
          language === 'uk'
            ? 'text-gold underline underline-offset-4'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        aria-label="Українська"
      >
        UA
      </button>
      <span className="text-gray-300">|</span>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-2 py-1 text-sm font-bold rounded transition ${
          language === 'en'
            ? 'text-gold underline underline-offset-4'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

